export const darkTheme = {
  background: '#121212', // Darker midnight black
  text: '#f5f5f5',
  accent: '#3498db',
  secondary: '#1e1e1e',
  borderColor: 'rgba(255, 255, 255, 0.1)',
  cardBackground: '#1e1e1e',
  cardBackgroundHover: '#282828',
};

export const lightTheme = {
  background: '#ffffff', // Apple light mode background
  text: '#1d1d1f', // Apple dark text
  accent: '#0071e3', // Apple blue
  secondary: '#f5f5f7', // Apple secondary background
  borderColor: 'rgba(0, 0, 0, 0.1)',
  cardBackground: '#f5f5f7',
  cardBackgroundHover: '#e8e8ed',
};